import type { ReactNode } from 'react';

import Button from 'components/Button';
import Status, { type StatusSize } from 'components/Status';
import { useGlobalPopoversContext, useSelectedStore } from 'contexts';
import { useFeatureToggle } from 'hooks';
import type { VariantId } from 'models/product';
import { useI18n } from 'utils/i18n';

interface BaseProps {
	className?: string;
	inStock: boolean;
	size?: StatusSize;
	// TODO: Change to string, was only node to enable store selector button
	// that is now built in.
	text: ReactNode;
}
interface PropsWithStoreSelector extends BaseProps {
	hasStoreSelector: true;
	variantId: VariantId;
}
interface PropsWithoutStoreSelector extends BaseProps {
	hasStoreSelector?: false;
	variantId?: VariantId;
}

type Props = PropsWithStoreSelector | PropsWithoutStoreSelector;

export default function StockStatus({
	className,
	hasStoreSelector,
	inStock,
	size,
	text,
	variantId,
}: Props) {
	const { t } = useI18n();
	const { openStoreSelector } = useGlobalPopoversContext();
	const { storesEnabled } = useFeatureToggle();
	const { selectedStore } = useSelectedStore();
	const hasSelectedStore = Boolean(selectedStore);
	const hasSelector =
		hasStoreSelector && !hasSelectedStore && storesEnabled && variantId;

	return (
		<Status
			variant={inStock ? 'positive' : 'negative'}
			size={size}
			className={className}
			text={
				<>
					{!hasSelector && text}
					{hasSelector && (
						<Button
							variant="text-inherit"
							underline={false}
							className="group/stock-btn"
							hasExpandedHitArea
							onClick={() => openStoreSelector(variantId)}
							aria-haspopup="dialog"
						>
							{text}&nbsp;
							<span className="inline-block underline group-hover/stock-btn:underline-strong">
								{t('select_store_button_text')}
							</span>
						</Button>
					)}
				</>
			}
		/>
	);
}
StockStatus.displayName = 'StockStatus';
